import React, {Component} from "react"
import PropTypes from "prop-types"
import MaskedInput from 'react-text-mask'
import _ from 'lodash'

export default class NRTNumberInput extends Component {


    state = {
        value : ''
    }

    componentDidMount() {
        this.input = React.createRef()
    }

    static getDerivedStateFromProps(nextProps) {
        return {
            value:nextProps.value
        }
    }



    focus() {
        const input = _.get(this.input , 'current.inputElement')

        if (input )
            input.focus()

    }


    handleChange = (evt) => {
        this.props.onChange(evt.target.value)
    }


    render() {

        const num = /\d/
        const mask = (input) => {

            const arr = Array(input.replace(/[^0-9]/g,'').length).fill(num)
            return arr
        }

        return (
            <div className={'nrt-form-input'}>

                <MaskedInput
                    tepe={'tel'}
                    mask={mask}
                    ref={this.input}
                    {...this.props}
                    value={this.state.value}
                    onChange={this.handleChange}
                />
            </div>
        )
    }
}

NRTNumberInput.propTypes = {
    onChange: PropTypes.func,
}

NRTNumberInput.defaultProps = {
}



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/NumberInput/index.js